@import 'apps/webcomponents/src/assets/common.scss';

:host([disabled]) {
  div.generic-dashboard-toolbar > * {
    pointer-events: none;
    opacity: 0.6;
  }

  .generic-dashboard-toolbar {
    gz-select {
      --tooltip-pointer-event: none;
    }
  }
}

:host,
.generic-dashboard-toolbar {
  display: flex;
  align-items: center;
  width: auto;
  gap: var(--spacer);
}
